import * as _unionBy from 'lodash/unionBy';
export function extractChatroomsFromServerResults(searchResults) {
    var chatroomsFromConversationsResults = searchResults.chatroomsPage.chatrooms;
    var chatroomsFromMessagesResults = searchResults.messagesPage.messages.map(function (message) { return message.chatroom; });
    var chatrooms = chatroomsFromConversationsResults.concat(chatroomsFromMessagesResults);
    return _unionBy(chatrooms, 'id');
}
